import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Product} from '../../../models/product';
import {RegistryService} from '../../../services/registry.service';
import {CartService} from '../../../services/cart.service';
import {environment} from '../../../../../environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {WishlistService} from '../../../services/wishlist.service';
import {Wishlist} from '../../../models/Wishlist/Wishlist';
import {AuthService} from '../../../../../services/auth.service';
import {ProductService} from '../../../services/product.service';
import {GoogleAnalyticsService} from '../../../services/google-analytics.service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-product-block',
    templateUrl: './product-block.component.html',
    styleUrls: ['./product-block.component.css']
})
export class ProductBlockComponent implements OnInit, OnDestroy {


    env = environment;
    isSimpleProduct = false;

    @Input() item: Product;
    @Input() isNewArrival = false;
    wishList: Wishlist;

    isAdding = false;
    hasSpecialPrice = false;
    itemAddedToWishListEvent;
    isCustomer = false;
    customerLoadedEvent;
    userLoggedOutEvent;
    currencyChangedEvent;
    currencyLoadedEvent;
    rate = 1;

    current_currency;
    price;
    price_format;
    settingsLoadedEvent;

    constructor(private router: Router, private registry: RegistryService, private authService: AuthService,
                private productService: ProductService,
                private cartService: CartService,
                private googleService: GoogleAnalyticsService,
                private snackBar: MatSnackBar, public wishListService: WishlistService,
                private dialog: MatDialog,
                private translate: TranslateService) {


        this.current_currency = registry.current_currency;
        this.currencyChangedEvent = this.registry.CurrencyChangedEvent$.subscribe(currency => {

            this.current_currency = this.registry.current_currency;
            this.recalcPrice();

        });

        this.settingsLoadedEvent = this.registry.SettingsLoadedEvent$.subscribe(settings => {

            this.price_format = this.registry.getSettingByID('price_format');
            console.log('Hi');
            this.recalcPrice();

        });

        // this.currencyLoadedEvent = this.registry.CurrencyLoadedEvent$.subscribe(currency => {
        //
        //     this.current_currency = this.registry.current_currency;
        //     this.recalcPrice();
        //
        // });

        this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

            this.isCustomer = true;
            this.wishList = this.registry.wishList;

        });

        this.userLoggedOutEvent = this.authService.UserLoggedOutEvent$.subscribe(() => {

            this.isCustomer = false;

        });


    }


    recalcPrice() {
        let rate = this.registry.getExchangeRate()
        this.price = this.item.price * rate;
        this.rate = rate;
    }

    getSpecialPrice() {
        return this.item.getSpecialPrice() * this.registry.getExchangeRate();
    }


    encode(content) {
        const temp = encodeURIComponent(content);
        // console.log(temp);
        return temp;
    }


    ngOnInit(): void {

        this.price = this.item.price * this.registry.getExchangeRate();
        this.hasSpecialPrice = this.item.hasSpecialPrice();
        this.price_format = ((this.registry.getSettingByID('price_format')) ? this.registry.getSettingByID('price_format') : '.3');

        this.recalcPrice();

        this.getProductType();
        if (this.registry.customer != undefined) {

            this.isCustomer = true;
            this.wishList = this.registry.wishList;

            // if (this.registry.wishList != null) {
            //     // console.log('the wishlist from the home');
            //     // console.log(this.wishList.items);
            // }

            // this.wishListService.getCustomerWishlist().subscribe(data => {
            //     this.wishList = data;
            // });

        } else {
            this.isCustomer = false;
            this.wishList = null;
        }


    }

    ngOnDestroy(): void {

        if (this.customerLoadedEvent) {
            this.customerLoadedEvent.unsubscribe();
        }

        if (this.currencyChangedEvent) {
            this.currencyChangedEvent.unsubscribe();
        }

        if (this.currencyLoadedEvent) {
            this.currencyLoadedEvent.unsubscribe();
        }

        if (this.settingsLoadedEvent) {
            this.settingsLoadedEvent.unsubscribe();
        }


    }

    getProductType() {
        if (this.item.type_id === 'simple') {
            this.isSimpleProduct = true;
        } else {
           this.isSimpleProduct = false;
        }
    }

    getProductName() {
        return this.item.name;
    }

    getProductPrice() {


        return this.item.price;

    }

    checkIfItemInFavorite(sku) {
        // if (this.wishList == null) {
        //     return false;
        // }

        // console.log('the wishlist from the func');
        // console.log(this.wishList);


        for (let i = 0; i < this.wishList?.items?.length; i++) {
            if (sku === this.wishList?.items[i]?.product.sku) {
                return true;

            }
        }
        return false;
    }


    getImageURL() {

        if (this.item.media_gallery_entries[0] == undefined) {
            console.log('image undefiend' + this.item);
        } else {
            return environment.baseCatalogUrl + environment.baseImagePath + '/' + this.item.getImage();
        }


    }

    goToProductDetailsPage() {
        // tslint:disable-next-line:max-line-length
        this.registry.currentProduct = this.item;
        this.router.navigate(['product/details/byk/' + this.encode(this.item.custom_attributes[1].value) + '/' + this.item.sku]);
        // {
        //     name: this.item.name,
        //         image: this.item.media_gallery_entries[0].file,
        //     price: this.item.price,
        //     sku: this.item.sku
        // }
    }

    addItemToWishlist(event) {
        event.preventDefault();
        const obj = {
            'id': this.item.id,
            'product': this.item,
        };
        this.wishList.items.push(obj);
        this.registry.wishList = this.wishList;
        this.wishListService.addWishlistItem(this.item.sku).subscribe(result => {

            this.googleService.eventEmitter('add_to_wishlist', 'ecommerce', 'add_to_wishlist', this.item.name + '-' + this.item.sku, this.item.price);

            this.openSuccessSnackBar(this.translate.instant('item_add_to_whishlist'), 'OK');
        });
    }


    deleteItemFromWishlist(event) {
        event.preventDefault();
        const obj = {
            'id': this.item.id,
            'product': this.item,
        };
        const index = this.wishList.items.findIndex(object => {
            return object.product.sku === obj.product.sku;
        });

        this.registry.wishList = this.wishList;

        this.wishListService.removeWishlistItem2(this.registry.customer.id,this.wishList.items[index].id).subscribe(result => {
            this.wishList.items.splice(index, 1);
            this.googleService.eventEmitter('remove_from_wishlist', 'ecommerce', 'remove_from_wishlist', this.item.name + '-' + this.item.sku, this.item.price);

            this.openSuccessSnackBar(this.translate.instant('remove_item_from_whishlist'), 'OK');

        });
    }

    addItemToCart() {

        // this.isAdding = true;
        const cartId = localStorage.getItem('cartId');
        this.cartService.addItemToCart(this.registry.cart, this.item.sku, 1).subscribe(resp => {

                // reload cart
                //   if(this.registry.cart.cartType == 'guest') {
                //       this.cartService.getGuestCart(this.registry.cart.quoteId).subscribe(cart => {
                //           cart.cartType = this.registry.cart.cartType;
                //           cart.quoteId = this.registry.cart.quoteId;
                //           this.registry.cart = cart;
                //           this.cartService.EmitCartUpdated(cart);
                //       })
                //   }else{
                const ctype = localStorage.getItem('customer_type');

                if (ctype == 'guest') {
                    this.cartService.getGuestCart(this.cartService.cart.quoteId, this.registry.getWebsiteId()).subscribe(cart => {
                        cart.cartType = 'guest';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                    });
                } else {
                    // user
                    this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {
                        cart.cartType = 'user';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                    });
                }

                // this.router.navigateByUrl('web/checkout-process');


                this.openSuccessSnackBar(this.translate.instant('item_add_to_cart'), '');

                this.dialog.open(ConfirmDialogComponent, {
                    width: '650px',
                    data: {parent: this, product: this.item}

                });
            },
            error => {

                this.openSuccessSnackBar(this.translate.instant('error_item_add_to_cart') + error.error.message, '');
                this.isAdding = false;

            }
        );

    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: 'right',
            panelClass: ['primary-snackbar'],
        });
    }


}
